(function() {
    'use strict';

    angular
        .module('app')
        .directive('columnResize', columnResize);

    columnResize.$inject = ['$window'];
    
    function columnResize ($window) {
        // Usage:
        //     <columnResize></columnResize>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA'
        };
        return directive;

        function link(scope, element, attrs) {
            $(element).resizable
        }
    }

})();